import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

import { Select } from 'src/modules/ui'

import { useRecipes } from '../hooks'
import { useAdmin } from '../../admin'
import { useActionRunner } from '../../../../notification'
import { Skeleton } from '@material-ui/lab'

const useStyles = makeStyles(theme => ({
  clearButton: {
    marginTop: theme.spacing(1),
  },
  filter: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  filterContainer: {
    backgroundColor: theme.palette.fadedPurple.main,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filterLabel: {
    color: theme.palette.purple.main,
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
  },
}))

const RecipeFilters = ({ className }) => {
  const classes = useStyles()

  const {
    fetchCategories,
    categories,
    setMenuFilters,
    setCategoryFilters,
    menuFilterChoices,
    categoryFilterChoices,
  } = useRecipes()
  const { fetchPurchasingEnvironments } = useAdmin()

  const [fetchData, isFetching] = useActionRunner(
    [() => fetchPurchasingEnvironments(), () => fetchCategories()],
    {
      initialFetchingState: true,
    }
  )

  useEffect(() => {
    fetchData()
  }, [])

  const menuChoices = [{ id: 'onMenu', name: 'On Menu' }]

  const handleChange = changeFunction => event =>
    changeFunction(event.target.value)

  // Filters
  const filters = [
    {
      clearText: 'Clear Categories',
      groupOptionsBy: 'group',
      options: categories.map(({ id, name, group }) => ({
        label: name,
        value: id,
        group,
      })),
      onChange: handleChange(setCategoryFilters),
      placeholder: 'Categories',
      value: categoryFilterChoices,
    },
    {
      clearText: 'Clear Choice',
      groupOptionsBy: 'group',
      options: menuChoices.map(({ id, name, group }) => ({
        label: name,
        value: id,
        group,
      })),
      onChange: handleChange(setMenuFilters),
      placeholder: 'Menu',
      value: menuFilterChoices,
    },
  ]

  return (
    <div className={className}>
      <div className={classes.filterContainer}>
        <Typography className={classes.filterLabel}>Filter</Typography>
        {!isFetching ? (
          <>
            {filters.map((filter, idx) => (
              <Select
                className={classes.filter}
                fullWidth
                key={idx}
                multiple
                {...filter}
              />
            ))}
          </>
        ) : (
          <>
            {filters.map((filter, idx) => (
              <Skeleton
                key={idx}
                variant="rect"
                height={40}
                style={{
                  borderRadius: 10,
                  marginTop: 12,
                }}
              />
            ))}
          </>
        )}
      </div>
    </div>
  )
}

export default RecipeFilters
